import { ProfitAndLoss } from "@goodfill/domain-properties";
import { formatCurrencyAmount } from "@goodfill/format-number";
import React from "react";

interface Props {
  value: ProfitAndLoss;
}

export const formatProfitAndLoss = (props: Props) =>
  formatCurrencyAmount({
    value: props.value.amount.toFixed(), // Intentionally no argument to get full precision
    numDecimals: 2,
    currency: props.value.currency,
  });

export const ProfitAndLossComponent: React.FC<Props> = (props) => {
  return <>{formatProfitAndLoss(props)}</>;
};
